import { render, staticRenderFns } from "./ActivesTypeForm.vue?vue&type=template&id=443756f0"
import script from "./ActivesTypeForm.vue?vue&type=script&lang=js"
export * from "./ActivesTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports